var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "220.897 72.737 494.986 508.291",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 337.598,282.512 h 4330 v 4330 h -4330 z",
    id: "path18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.333333, 0, 0, -1.333333, 0, 666.666687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(0.1, 0, 0, 0.1, 102.20858, 2.240678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 5000 V 5000 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    clipPath: "url(#clipPath20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "matrix(4351.2,0,0,4351.2,326.9,271.9)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M 4329.19,2550 C 4329.19,1539.5 3510.02,720.332 2499.53,720.332 1489.03,720.332 669.863,1539.5 669.863,2550 c 0,1010.49 819.167,1829.66 1829.667,1829.66 1010.49,0 1829.66,-819.17 1829.66,-1829.66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2499.53,4379.66 c -796.27,0 -1473.6,-508.7 -1725.065,-1218.81 H 4224.59 c -251.45,710.11 -928.8,1218.81 -1725.06,1218.81",
    style: {
      fill: "#f57733",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 774.727,1938.41 C 1026.39,1228.69 1703.54,720.34 2499.53,720.34 c 795.99,0 1473.14,508.35 1724.81,1218.07 H 774.727",
    style: {
      fill: "#228f45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4329.19,2550 c 0,214.23 -36.94,419.81 -104.6,610.85 H 774.465 C 706.809,2969.81 669.863,2764.23 669.863,2550 c 0,-214.5 37.043,-420.33 104.864,-611.59 H 4224.34 c 67.82,191.26 104.85,397.09 104.85,611.59",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fill: "rgb(240, 240, 240)"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2499.17,3045.32 -13.86,-275.94 14.95,-156.96 13.88,156.96 -13.88,275.94 c 14.61,0 28.48,-0.73 42.35,-2.18 l -0.73,-1.46 c 0,-13.15 10.22,-24.11 22.63,-24.11 11.68,0 21.18,9.49 22.26,20.45 13.89,-2.92 27.02,-5.11 40.52,-9.49 l -84.68,-262.81 -27,-155.47 54.73,148.9 58.4,269.38 c 13.16,-4.38 26.3,-8.02 39.44,-13.15 -0.74,-2.18 -1.84,-5.09 -1.84,-8.01 0,-12.41 10.22,-22.63 23.01,-22.63 8.75,0 17.51,5.83 20.8,13.87 12.41,-5.85 24.46,-12.42 36.87,-19.72 l -150.03,-230.69 -66.42,-144.54 91.61,129.21 125.93,245.29 c 11.32,-6.57 23,-13.87 34.68,-21.18 -3.29,-4.37 -5.12,-8.75 -5.12,-14.59 0,-12.41 10.22,-22.63 23.01,-22.63 7.28,0 13.86,2.91 17.88,9.49 10.95,-9.49 21.18,-18.98 30.65,-28.48 l -204.39,-184.67 -101.11,-121.93 121.55,100.74 185.05,205.13 c 9.5,-10.2 18.99,-19.7 27.74,-30.64 -5.48,-4.4 -8.02,-10.96 -8.02,-17.53 0,-12.41 10.2,-22.64 22.26,-22.64 5.47,0 9.49,1.46 13.5,4.4 8.4,-11.68 15.71,-23.36 22.27,-35.04 l -245.29,-125.57 -129.21,-91.99 143.45,65.71 231.77,151.11 c 7.67,-13.13 13.87,-27.02 20.07,-38.7 -7.66,-3.64 -13.86,-12.41 -13.86,-21.9 0,-12.41 10.22,-22.62 22.28,-22.62 3.64,0 6.2,0.73 8.74,2.19 4.39,-13.14 8.41,-25.55 11.68,-38.7 l -269.73,-56.93 -147.82,-54.75 155.49,26.27 262.79,83.95 c 3.29,-11.68 6.58,-26.28 9.14,-39.41 -11.33,-1.46 -19.72,-10.23 -19.72,-22.64 0,-12.4 10.58,-22.63 22.99,-22.63 h 2.2 c 1.46,-13.13 1.46,-27.73 1.46,-40.86 l -275.22,13.13 -157.68,-13.89 157.68,-15.32 275.22,14.59 c 0,-14.59 0,-28.46 -1.46,-41.59 h -2.2 c -12.41,0 -22.99,-10.96 -22.99,-22.64 0,-11.68 8.39,-20.44 19.34,-22.62 -2.56,-13.87 -5.47,-27.02 -8.76,-40.15 l -93.8,29.92 -168.99,54.76 -155.49,26.28 h 0.73 -0.73 l 147.82,-54.76 269.73,-57.68 c -3.27,-13.13 -7.29,-27 -12.41,-38.68 l -2.92,0.73 c -2.18,0 -3.64,0 -5.09,0 -12.79,0 -23.01,-9.5 -23.01,-22.63 0,-3.64 0.73,-5.83 2.19,-8.77 1.1,-3.64 3.29,-6.55 6.2,-8.74 l 1.83,-0.73 2.19,-1.46 1.46,-1.47 c -5.83,-12.42 -12.42,-24.83 -19.35,-36.51 l -231.42,149.66 h -0.35 l -143.45,65.7 h 0.73 l 75.2,-52.56 53.28,-37.95 245.29,-125.58 c -7.32,-12.4 -14.6,-24.81 -22.64,-35.76 -3.64,2.19 -8.39,3.64 -13.13,3.64 -12.79,0 -22.64,-9.47 -22.64,-21.88 0,-7.31 2.92,-13.89 8.4,-17.53 -9.12,-10.23 -18.24,-20.45 -27.74,-29.92 l -185.05,204.39 -121.2,100.75 100.76,-121.92 204.39,-184.7 c -9.47,-10.2 -18.97,-18.24 -29.57,-27 -4.37,3.64 -9.12,5.12 -14.22,5.12 -12.41,0 -22.63,-10.95 -22.63,-22.63 0,-4.4 0.73,-7.32 1.81,-10.23 -12.03,-7.31 -24.44,-15.34 -36.49,-23.36 l -125.93,245.29 -91.61,129.94 66.06,-143.81 150.01,-232.15 c -12.03,-6.58 -24.08,-13.13 -36.49,-18.98 -3.29,8.76 -11.33,13.87 -20.45,13.87 -12.76,0 -22.98,-10.96 -22.98,-22.64 0,-2.91 0.72,-5.83 1.46,-8.74 -13.14,-4.4 -25.92,-8.77 -39.44,-11.68 l -58.4,270.1 -54.73,146.72 v 0.73 l 27,-155.49 84.68,-262.81 c -13.5,-3.65 -27.02,-7.29 -40.52,-8.75 -1.82,10.22 -11.31,18.97 -22.26,18.97 -13.14,0 -22.63,-10.22 -22.63,-21.9 0,-1.46 0,-2.19 0,-2.92 -13.87,-1.46 -27.74,-2.19 -41.62,-2.19 l 13.88,275.22 -14.61,157.68 -14.22,-157.68 13.86,-275.22 c -14.59,0 -28.1,0.73 -42.34,2.19 0,0.73 0,1.46 0,2.92 0,11.68 -10.23,21.9 -22.99,21.9 -10.95,0 -20.44,-8.75 -22.28,-18.97 -13.49,2.18 -26.63,5.1 -39.41,8.75 l 84.68,262.81 26.28,154.76 -54.74,-146.72 -57.68,-270.1 c -13.13,2.91 -26.27,7.28 -39.78,11.68 1.1,2.91 1.83,5.83 1.83,8.74 0,11.68 -10.23,22.64 -22.28,22.64 -9.49,0 -17.51,-5.83 -21.52,-13.87 -12.06,5.85 -24.47,12.4 -36.51,18.98 l 150.01,232.15 65.72,143.81 -91.26,-129.22 -125.57,-246.01 c -12.03,8.02 -24.09,15.33 -35.39,23.36 2.54,2.91 4.36,7.29 4.36,12.41 0,13.14 -10.21,23.37 -22.25,23.37 -7.68,0 -13.89,-3.68 -17.53,-8.77 -10.95,9.49 -21.17,17.53 -30.66,27.73 l 205.13,184.7 100.75,121.92 -121.55,-100.75 -185.07,-204.39 c -10.2,9.47 -19.33,20.42 -28.45,29.92 5.09,4.37 8.76,10.94 8.76,18.26 0,12.4 -10.23,21.89 -22.63,21.89 -5.13,0 -9.87,-1.47 -13.52,-3.66 -8.03,10.96 -15.32,22.64 -22.25,35.04 l 246.01,126.3 128.11,89.79 -143.45,-65.7 -231.41,-149.66 c -6.93,11.68 -12.4,23.36 -18.61,36.51 8.75,2.93 14.6,10.94 14.6,20.44 0,13.13 -9.87,23.36 -23.01,23.36 -3.27,0 -6.56,-0.73 -9.47,-2.19 -4.39,12.41 -8.77,26.28 -12.78,40.14 l 270.09,57.68 148.56,54.76 -156.21,-26.28 -262.81,-84.68 c -3.65,13.13 -6.21,26.28 -9.13,40.87 11.33,1.46 19.72,10.22 19.72,21.9 0,12.41 -10.22,22.64 -22.63,22.64 h -2.56 c -0.74,13.13 -1.83,27 -1.83,41.59 l 275.6,-14.59 157.31,15.32 -157.31,13.89 -275.6,-13.13 c 0,13.13 1.09,27.73 1.83,40.86 1.45,0 2.56,0 4.02,0 12.4,0 22.63,9.5 22.63,22.63 0,12.41 -9.12,21.18 -21.18,22.64 2.92,13.13 5.48,27.73 9.13,39.41 l 262.81,-83.95 156.21,-26.27 -148.56,54.75 -270.09,57.66 c 4.01,13.89 8.39,27.02 12.78,39.43 2.19,-0.73 5.83,-1.46 8.39,-1.46 12.76,0 22.64,10.22 22.64,22.64 0,9.47 -5.85,17.51 -13.52,20.42 5.85,13.16 12.05,25.56 18.98,37.97 l 231.41,-151.11 144.18,-65.71 -128.84,91.99 -246.01,125.57 c 6.93,11.68 14.6,23.36 22.62,35.76 3.28,-3.66 8.75,-5.12 13.5,-5.12 12.05,0 22.64,10.23 22.64,22.64 0,6.57 -3.66,13.13 -8.4,18.25 8.4,10.22 17.53,19.72 27.38,29.92 l 185.05,-205.13 121.92,-100.74 -100.75,121.93 -205.13,184.67 c 10.22,9.5 20.08,18.99 30.66,27.75 3.64,-5.12 10.22,-8.76 17.53,-8.76 12.76,0 22.99,10.22 22.99,23.36 0,5.11 -2.19,9.49 -4.75,13.86 11.68,6.59 23.01,14.61 35.04,21.18 l 125.57,-245.29 91.26,-128.47 -65.72,143.8 -150.01,230.69 c 12.04,7.3 24.09,13.87 36.13,19.72 3.66,-8.77 11.68,-14.6 21.17,-14.6 12.78,0 22.63,10.2 22.63,21.88 0,3.66 -0.73,7.31 -1.45,9.49 12.78,5.13 26.65,8.77 39.78,13.15 l 58.4,-269.38 54.76,-148.9 -26.65,155.47 -84.68,262.81 c 13.15,4.38 26.28,6.57 40.15,9.49 1.45,-10.96 10.94,-19.7 22.25,-19.7 12.79,0 23.01,10.21 23.01,23.36 v 2.19 c 13.5,1.45 27.38,1.45 41.24,1.45 m 0.36,53.29 c -302.96,0 -548.97,-245.29 -548.97,-548.25 0,-302.94 246.01,-548.96 548.97,-548.96 302.96,0 548.97,246.02 548.97,548.96 -0.35,302.96 -246.01,548.25 -548.97,548.25",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2500.26,2632.12 c 45.26,0 81.76,-37.23 81.76,-81.76 0,-45.24 -36.5,-82.49 -81.76,-82.49 -45.97,0 -82.49,37.25 -82.49,82.49 0,44.53 36.52,81.76 82.49,81.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2500.26,2613.16 c 34.68,0 63.15,-27.76 63.15,-62.8 0,-35.77 -28.47,-64.22 -63.15,-64.22 -35.4,0 -64.23,28.45 -64.23,64.22 0,35.04 28.83,62.8 64.23,62.8",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2452.26,225.559 -0.01,0.121 0.01,-0.121",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2453.08,220.379 h 0.01 c -0.31,1.48 -0.55,2.953 -0.73,4.391 0.18,-1.461 0.42,-2.93 0.72,-4.391",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2458.45,205.34 -0.11,0.211 0.11,-0.211",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2457.93,206.34 -0.41,0.84 0.41,-0.84",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2454.59,214.59 c 0.79,-2.5 1.75,-4.93 2.85,-7.231 -1.12,2.352 -2.06,4.782 -2.83,7.231 h -0.02",
    style: {
      fill: "#343182",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/IndiaFlag.300092ef3663d76511179a2bcbd7e163.svg";
export { ForwardRef as ReactComponent };